import {
    Card,
    Tabs,
    Table,
    Button,
    Space,
    Modal,
    Form,
    Input,
    DatePicker,
    Select,
    message,
    Descriptions,
    Avatar,
} from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import API_BASE_URL from '../../config/api';
import IframeEmbed from '../../components/IframeEmbed';
import getFileUrl from '../../utils/fileUrl';

const { TabPane } = Tabs;

const MonkDetailPage = () => {
    const { id } = useParams(); // monk id
    const [monk, setMonk] = useState(null);
    const [educations, setEducations] = useState([]);
    const [experiences, setExperiences] = useState([]);
    const [titles, setTitles] = useState([]);
    const [temple, setTemple] = useState([]);
    const [form] = Form.useForm();
    const [modalVisible, setModalVisible] = useState(false);
    const [currentType, setCurrentType] = useState(null); // 'education' | 'experience' | 'title'
    const [editData, setEditData] = useState(null); // record ที่ต้องการแก้ไข

    const fetchData = async () => {
        const res = await axios.get(`${API_BASE_URL}/api/monks/${id}/detail`);
        //console.log('res', res.data);
        setMonk(res.data.monk);
        setEducations(res.data.educations);
        setExperiences(res.data.experiences);
        setTitles(res.data.titles);
        setTemple(res.data.temple);
    };

    useEffect(() => {
        fetchData();
    }, []);

    const handleEdit = async (type, record) => {
        setCurrentType(type);
        setEditData(record);

        form.setFieldsValue({
            ...record,
            granted_date: record.granted_date ? dayjs(record.granted_date) : null,
        });
        setModalVisible(true);

    };

    const handleDelete = async (type, recordId) => {
        try {
            await axios.delete(`${API_BASE_URL}/api/monks/${id}/${type}/${recordId}`);
            message.success('ลบข้อมูลเรียบร้อยแล้ว');
            fetchData();
        } catch (err) {
            console.error(err);
            message.error('เกิดข้อผิดพลาดในการลบข้อมูล');
        }
    };

    const handleAdd = (type) => {
        setCurrentType(type);
        setEditData(null);
        form.resetFields();
        setModalVisible(true);
    };



    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            const payload = {
                ...values,
                granted_date: values.granted_date?.format('YYYY-MM-DD'),
            };
            const url = `${API_BASE_URL}/api/monks/${id}/${currentType}${editData ? `/${editData.id}` : ''}`;
            const method = editData ? 'put' : 'post';
            await axios[method](url, payload);
            message.success(editData ? 'อัปเดตข้อมูลสำเร็จ' : 'เพิ่มข้อมูลสำเร็จ');
            setModalVisible(false);
            fetchData();
        } catch (err) {
            console.error(err);
            message.error('เกิดข้อผิดพลาดในการบันทึก');
        }
    };

    const renderColumns = (type) => [
        {
            title: type === 'education'
                ? 'ระดับ'
                : type === 'experience'
                    ? 'ตำแหน่ง'
                    : 'สมณศักดิ์',
            dataIndex:
                type === 'education'
                    ? 'level'
                    : type === 'experience'
                        ? 'position'
                        : 'title_name',
        },
        {
            title: 'รายละเอียด',
            dataIndex: 'description',
        },
        {
            title: 'จัดการ',
            render: (_, record) => (
                <Space>
                    <Button onClick={() => handleEdit(type, record)}>แก้ไข</Button>
                    <Button danger onClick={() => handleDelete(type, record.id)}>ลบ</Button>
                </Space>
            ),
        },
    ];

    return (
        <Card title={`ประวัติ: ${monk?.first_name_th} ${monk?.dharma_name} (${monk?.last_name_th})`}>

            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
                {monk?.photo ? (
                    <img
                        src={getFileUrl(monk.photo)}
                        alt="รูปพระ"
                        style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: '50%' }}
                    />
                ) : (
                    <Avatar size={150} icon={<UserOutlined />} />
                )}
            </div>

            {monk && (
                <Descriptions bordered column={1} size="small" style={{ marginBottom: 24 }}>
                    <Descriptions.Item label="ฉายา">{monk.dharma_name}</Descriptions.Item>
                    <Descriptions.Item label="ชื่อ-สกุล">{`${monk.first_name_th} ${monk.last_name_th}`}</Descriptions.Item>
                    <Descriptions.Item label="วันเกิด">{monk.birth_date}</Descriptions.Item>
                    <Descriptions.Item label="วันที่บรรพชา/อุปสมบท">{monk.ordination_date}</Descriptions.Item>
                    <Descriptions.Item label="วัดต้นสังกัด">{temple[0].name}</Descriptions.Item>
                </Descriptions>
            )}


            <Tabs defaultActiveKey="1">
                <TabPane tab="ประวัติการศึกษา" key="1">
                    <Table dataSource={educations} columns={renderColumns('education')} rowKey="id" />
                    <Button type="primary" onClick={() => handleAdd('education')}>เพิ่ม</Button>
                </TabPane>
                <TabPane tab="ประวัติการทำงาน" key="2">
                    <Table dataSource={experiences} columns={renderColumns('experience')} rowKey="id" />
                    <Button type="primary" onClick={() => handleAdd('experience')}>เพิ่ม</Button>
                </TabPane>
                <TabPane tab="สมณศักดิ์" key="3">
                    <Table dataSource={titles} columns={renderColumns('title')} rowKey="id" />
                    <Button type="primary" onClick={() => handleAdd('title')}>เพิ่ม</Button>
                </TabPane>
            </Tabs>
            {/* 
            <div>
                <h1>อัพโหลดไฟล์เอกสาร</h1>
                <IframeEmbed src="https://cloud.atom-soft.com/index.php/s/mnf8bWqAfy9feTF" height="1000px" style={{ borderRadius: '50' }} />
            </div> */}

            <Modal
                title={editData ? 'แก้ไขข้อมูล' : 'เพิ่มข้อมูล'}
                visible={modalVisible}
                onCancel={() => setModalVisible(false)}
                onOk={handleSubmit}
            >
                <Form form={form} layout="vertical">
                    {currentType === 'education' && (
                        <>
                            <Form.Item name="level" label="ระดับ" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="institution" label="สถานศึกษา">
                                <Input />
                            </Form.Item>
                            <Form.Item name="year" label="ปี">
                                <Input />
                            </Form.Item>
                        </>
                    )}

                    {currentType === 'experience' && (
                        <>
                            <Form.Item name="position" label="ตำแหน่ง" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="location" label="สถานที่/วัด">
                                <Input />
                            </Form.Item>
                            <Form.Item name="start_year" label="ปีเริ่มต้น">
                                <Input />
                            </Form.Item>
                            <Form.Item name="end_year" label="ปีสิ้นสุด">
                                <Input />
                            </Form.Item>
                        </>
                    )}

                    {currentType === 'title' && (
                        <>
                            <Form.Item name="title_name" label="ชื่อสมณศักดิ์" rules={[{ required: true }]}>
                                <Input />
                            </Form.Item>
                            <Form.Item name="granted_by" label="ผู้มอบ">
                                <Input />
                            </Form.Item>
                            <Form.Item name="granted_date" label="วันที่ได้รับ">
                                <DatePicker style={{ width: '100%' }} />
                            </Form.Item>
                        </>
                    )}

                    <Form.Item name="description" label="รายละเอียดเพิ่มเติม">
                        <Input.TextArea rows={3} />
                    </Form.Item>
                </Form>
            </Modal>
        </Card>
    );
};

export default MonkDetailPage;
